import React from 'react';
import NutritionReports from 'components/business/NutritionReports';

export const ReportsCtx = React.createContext({});

function NutritionPageProvider(props) {
  const ctx = {
  };
  return (
    <ReportsCtx.Provider value={ ctx }>
      {props.children}
    </ReportsCtx.Provider>
  );
}

function NutritionPage() {
  return (
    <NutritionPageProvider>
      <NutritionReports />
    </NutritionPageProvider>
  );
}

export default NutritionPage;
